import { render, staticRenderFns } from "./BandFilters.vue?vue&type=template&id=0a8fa6e8&scoped=true&"
import script from "./BandFilters.vue?vue&type=script&lang=js&"
export * from "./BandFilters.vue?vue&type=script&lang=js&"
import style0 from "./BandFilters.vue?vue&type=style&index=0&id=0a8fa6e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8fa6e8",
  null
  
)

export default component.exports